import React from "react";
import "./navMenu.css";
import {getMainCharacterData} from "../includes/axios/getMainCharacterData.js";
import { BrowserRouter, Route, browserHistory, Switch, Link, Router,withRouter} from "react-router-dom";
import { Redirect } from 'react-router';
import ReactDOM from 'react-dom';

var NavMenu = class NavMenu extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            currentPageHover:"Home",
            currentSelectedPage:"Home",
            hoverContainer:"hideMe",
            selectedContainer:"showMe"
        }

    }//end constructor()
    
//when you hover over a button, the div which shows the hover state is given the class "showMe"
//The div the shows the selected page is given the class "hideMe"
//then when you leave the menu area, the classes are switched. this way its not constantly switching 
//between hovers and look all jittery
componentDidMount() {
  var url = window.location.href;
  console.log("REDUX current: " + this.props.menu.currentPage)
}


componentDidUpdate(prevProps){
    //console.log("Previous: " + prevProps.menu.currentPage + " --- New: " + this.props.menu.currentPage);
    
    if(prevProps.menu.currentPage != this.props.menu.currentPage){
        var menuButtons = ['home','character','characterDatabase','comicDetail','comicDatabase','videos']
        var currentPageTitle = ['Home','Character Profile','Character Database','Comic Detail','Comic Database','Video Database']
        menuButtons.map(function(item,index){
            
            if(item === this.props.menu.currentPage){
                var name = ReactDOM.findDOMNode(this.refs[item]);
                name.classList.add("selected")
                //use menuButtons[] index to access the title from currentPageTitle[] since they have the same indexs
                this.setState({currentSelectedPage:currentPageTitle[index]});
            }
            else{
                var name = ReactDOM.findDOMNode(this.refs[item]); 
                name.classList.remove("selected")       
            }
        },this);        
    }//end if()
}//end componentDidUpdate()




highlightCurrentPage(currentPage){
    //console.log("REDUX current: " + this.props.menu.currentPage)

    // var menuButtons = ['home','character','characterDatabase','comic','comicDatabase','videos']
    // menuButtons.map(function(item,index){
    //     if(item === currentPage){
    //         var name = ReactDOM.findDOMNode(this.refs[item]);
    //         // name.style.backgroundPositionY = "-30px";
    //         // name.style.borderColor = "#fff";
    //         name.classList.add("selected")
    //     }
    //     else{
    //         var name = ReactDOM.findDOMNode(this.refs[item]);
    //         // name.style.backgroundPositionY = "0px"; 
    //         // name.style.borderColor = "#2b98fb";  
    //         name.classList.remove("selected")       
    //     }
    //},this);
}




    render(props) {
      const routeBase = localStorage.getItem("routeBase"); 

      return (
        <div className = "navMenuContainerWrapper">  
            <div className="navMenuContainer" ref = "navMenuContainer"
                //only show the 'selectedContainer and hide the hover one when you leave the menu area
                onMouseLeave = {()=>{this.setState({
                    hoverContainer:"hideMe",
                    selectedContainer:"showMe"                    
                })}}
            >


                <Link to={routeBase + "/"} className="navMenuButton selected" id="iconHome" ref="home"
                    onMouseEnter = {()=>{
                        this.setState({
                            currentPageHover:"Home",
                            hoverContainer:"showMe",
                            selectedContainer:"hideMe"
                        });  
                    }}

                    onClick = {()=>{
                        this.setState({currentSelectedPage:"Home"});
                        //this.highlightCurrentPage("home");
                    }}
                >    
                </Link>  
                

                <Link to={routeBase + "/character"} className="navMenuButton" id="iconCharacter" ref = "character"
                    onMouseEnter = {()=>{
                        this.setState({
                            currentPageHover:"Character Profile",
                            hoverContainer:"showMe",
                            selectedContainer:"hideMe"
                        });  
                    }}
                    onClick = {()=>{
                        this.setState({currentSelectedPage:"Character Profile"});
                        //this.highlightCurrentPage("character");
                    }}
                >   
                </Link> 


                <Link to={routeBase + "/characterDatabase/page" + this.props.pagination.currentPage} className="navMenuButton" id="iconCharacterDatabase" ref="characterDatabase"
                    onMouseEnter = {()=>{
                        this.setState({
                            currentPageHover:"Character Database",
                            hoverContainer:"showMe",
                            selectedContainer:"hideMe"
                        });  
                    }}
                    onClick = {()=>{
                        this.setState({currentSelectedPage:"Character Database"});
                        //this.highlightCurrentPage("characterDatabase");
                    }}                
                >  
                </Link> 


                <Link to={routeBase + "/comicDetail"} className="navMenuButton" id="iconComic" ref="comicDetail"
                    onMouseEnter = {()=>{
                        this.setState({
                            currentPageHover:"Comic Detail",
                            hoverContainer:"showMe",
                            selectedContainer:"hideMe"
                        });  
                    }}
                    onClick = {()=>{
                        this.setState({currentSelectedPage:"Comic Detail"});
                        //this.highlightCurrentPage("comic");
                    }}                
                > 
                </Link>

                <Link to={routeBase + "/comicDatabase/page" + this.props.pagination.currentPage} className="navMenuButton" id="iconComicDatabase" ref="comicDatabase"
                    onMouseEnter = {()=>{
                        this.setState({
                            currentPageHover:"Comic Database",
                            hoverContainer:"showMe",
                            selectedContainer:"hideMe"
                        });  
                    }}
                    onClick = {()=>{
                        this.setState({currentSelectedPage:"Comic Database"})
                        //this.highlightCurrentPage("comicDatabase");
                    }}                  
                >   
                </Link>  

                <Link to={routeBase + "/videosPage"} className="navMenuButton" id="iconVideos" ref="videos"
                    onMouseEnter = {()=>{
                        this.setState({
                            currentPageHover:"Video Database",
                            hoverContainer:"showMe",
                            selectedContainer:"hideMe"
                        });  
                    }}
                    onClick = {()=>{
                        this.setState({currentSelectedPage:"Video Database"});
                        //this.highlightCurrentPage("videos");
                    }}                
                >
                </Link>  
            </div>{/* end of navMenuContainer */}







            <div className = "currentPageHolder">
                <p className = {this.state.hoverContainer}> {this.state.currentPageHover}</p>
                <p className = {this.state.selectedContainer}  style={{'color':"white"}}>{this.state.currentSelectedPage}</p>
            </div>
        </div>
      );
    }
  }

  export default withRouter(NavMenu);


// WEBPACK FOOTER //
// ./src/components/navMenu/navMenu.js